import { Link } from 'react-router-dom';

export default function CheckoutSuccess() {
  return (
    <div className="center-page">
      <div className="center-card">
        <div style={{ fontSize: '4rem', marginBottom: '20px' }}>✓</div>
        <h1>Payment Successful!</h1>
        <p>
          Thank you for your purchase! We've sent your access code to your email address.
          Check your inbox (and spam folder) for the access code.
        </p>

        <div style={{
          background: 'var(--bg-input)',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '30px',
          textAlign: 'left'
        }}>
          <h3 style={{ marginBottom: '12px', fontSize: '1rem' }}>What's Next?</h3>
          <ol style={{ color: 'var(--text-muted)', paddingLeft: '20px', lineHeight: '1.8' }}>
            <li>Check your email for the access code</li>
            <li>Click the link in the email or enter your code below</li>
            <li>Enjoy unlimited stream access!</li>
          </ol>
        </div>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/redeem" className="btn btn-primary">
            Enter Access Code
          </Link>
          <Link to="/" className="btn btn-secondary">
            Back to Streams
          </Link>
        </div>
      </div>
    </div>
  );
}
